import React from 'react';
import styled from 'styled-components';
import {FlexContainer} from 'app/styles/content';
import {Image, TextBadge, IconBadge, FONTS} from '@fupa/fupa-uikit';
import {LinkOnComponent} from 'app/components/links/link';
import {CustomName, PlayerContainer, PlayerData, Position} from 'app/components/LineUp/LineUpPlayerStyles';
import {ProfilePhoto, ProfileTypography} from 'app/components/profile/ProfileStyles';
import {getPlayerShortName} from 'app/helpers/helpers';
import {
  Tracktics,
  TwoCards,
  Football,
  Assist,
  RedCard,
  SubstitutionInOut,
  SubstitutionIn,
  SubstitutionOut,
  YellowCard,
} from 'app/components/icons';

const TrackticsIconContainer = styled(FlexContainer)`
  position: absolute;
  bottom: 0;
  right: 0;
  align-items: center;
  font-size: ${FONTS['16']};
`;

const StyledIconBadge = styled(IconBadge)`
  font-size: ${FONTS['12']};
`;

const LineUpPlayer = ({player, type}) => {
  const stats = player.statistics;
  const JerseyNumber = player.jerseyNumber ? <TextBadge value={player.jerseyNumber.toString()} position={1} /> : '';
  const isDeactivated = player.player.isDeactivated;

  const values = [];
  if (stats.substituteIn && stats.substituteOut) {
    values.push('substitutionInOut');
  } else if (stats.substituteIn) {
    values.push('substitutionIn');
  } else if (stats.substituteOut) {
    values.push('substitutionOut');
  }
  if (stats.redCard) {
    values.push('red');
  } else if (stats.yellowRedCard) {
    values.push('yellowRed');
  } else if (stats.yellowCard) {
    values.push('yellow');
  }
  if (stats.goals || stats.penaltyHits) {
    values.push('goal');
  }
  if (stats.assists) {
    values.push('assist');
  }

  const checkFlags = () => {
    return values.map((value, index) => <StyledIconBadge key={value} value={getIcon(value)} position={3 + index} />);
  };

  const getIcon = value =>
    ({
      substitutionInOut: <SubstitutionInOut fontSize='inherit' />,
      substitutionIn: <SubstitutionIn fontSize='inherit' />,
      substitutionOut: <SubstitutionOut fontSize='inherit' />,
      yellowRed: <TwoCards fontSize='inherit' />,
      red: <RedCard fontSize='inherit' />,
      yellow: <YellowCard fontSize='inherit' />,
      goal: <Football fontSize='inherit' />,
      assist: <Assist fontSize='inherit' />,
    }[value]);

  let showPosition, flags, captain, showTrackticsIcon;
  if (type !== 'coach') {
    showPosition = (
      <ProfileTypography isDeactivated={isDeactivated} variant='caption1'>
        {player.position}
      </ProfileTypography>
    );
    flags = checkFlags();
    captain = player.captain ? <TextBadge value='C' position={2} /> : '';
  }
  if (player.statistics.details) {
    showTrackticsIcon = (
      <TrackticsIconContainer>
        <Tracktics fontSize='inherit' />
      </TrackticsIconContainer>
    );
  }

  const playerContent = (
    <PlayerContainer>
      <ProfilePhoto>
        {flags}
        {JerseyNumber}
        {captain}
        <Image entity='player' src={player.player.image} circle={true} ratio='1:1' width={64} height={64} />
      </ProfilePhoto>
      <PlayerData>
        <CustomName isDeactivated={isDeactivated} variant='body1'>
          {getPlayerShortName(player.player)}
        </CustomName>
        <Position>
          {showPosition}
          {showTrackticsIcon}
        </Position>
      </PlayerData>
    </PlayerContainer>
  );

  return isDeactivated ? (
    playerContent
  ) : (
    <LinkOnComponent enablehover={true.toString()} to={`/player/${player.player.slug}`}>
      {playerContent}
    </LinkOnComponent>
  );
};

export default LineUpPlayer;
